import React from 'react'
import './goods-info.less'
import { InputItem } from 'antd-mobile'
import { withRouter } from 'react-router'

@(withRouter as any)
class goodsInfo extends React.Component<any> {
  navTo = () => {
    this.props.history.push({ pathname: '/fillorder/list' })
  }
  render() {
    let goods_covers = this.props.goods_covers || []
    let list
    if (goods_covers.length > 3) {
      list = goods_covers.slice(0, 3)
    } else {
      list = goods_covers
    }
    const goodsItems = list.map((item: any, index: number) => (
      <div className="img-div" key={index}>
        <img src={item} alt="anxin.png" />
      </div>
    ))
    return (
      <div className="goods-info">
        <div className="title font-7">
          <img
            className="logo"
            src={process.env.PUBLIC_URL + '/assets/img/shopping_cart_logo.png'}
            alt="anxin.png"
          />
          安歆公寓
        </div>
        <div onClick={this.navTo} className="goods font_gray">
          <div className="flex-lvc">
            {goodsItems}共{this.props.goods_count}件
          </div>

          <i className="iconfont font-7 icon-next">&#xe60e;</i>
        </div>
        <div>
          <InputItem
            placeholder="请填写备注留言（50字以内）"
            maxLength={50}
            clear
            moneyKeyboardAlign="left"
            style={{
              fontSize: '0.15rem',
            }}
            onChange={(e: any) => this.props.messageChange(e)}
          >
            <span className="font-7">备注留言</span>
          </InputItem>
        </div>
      </div>
    )
  }
}
export default goodsInfo
